
let VUE_APP_BASE_URL= null;
if (process.env.NODE_ENV == 'development') {
	// VUE_APP_BASE_URL = 'http://106.15.95.149:8056/api'
	// VUE_APP_BASE_URL = 'http://192.168.2.30:8056/api'
	VUE_APP_BASE_URL = 'https://reagent.sinanoaq.cn/exam'
}else {
	// VUE_APP_BASE_URL = 'http://192.168.2.15:8082'
	// 正式环境
	// VUE_APP_BASE_URL = 'http://47.108.222.15:8000'
	// 国泰
	VUE_APP_BASE_URL = 'https://reagent.sinanoaq.cn/exam'
}

export default VUE_APP_BASE_URL